var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.618,
    height: 21.507,
    viewBox: "0 0 22.618 21.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M190.225,316.6l-3.5,7.082-7.812,1.13,5.658,5.515-1.336,7.781,6.988-3.672,6.988,3.672-1.336-7.781,5.658-5.515-7.812-1.13Z",
    transform: "translate(-178.916 -316.602)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrella);
export default __webpack_public_path__ + "static/media/estrella.6ec8e22201ed894c902d63e74076d07f.svg";
export { ForwardRef as ReactComponent };